import paramMapping from '../settings/paramMapping';
import baseParamMapping from '../settings/baseParams';
import eventTypes from '../settings/eventTypes';
export const remapParams = (object, mapping) => {
    // start with an empty string, loop through keys in the object and convert the key and value to a url parameter
    return Object.keys(object).reduce((result, key) => {
        // ignore if the eventType isn't covered in the eventTypes settings or value is null/empty
        if (!object[key] ||
            (key === 'eventType' && eventTypes[object[key]] === undefined))
            return result;
        // if the key doesn't have a remapping specified, use the key as is.
        const mappingKey = mapping && mapping[key] ? mapping[key] : key;
        const nextMappingLevel = mapping && typeof mapping[key] === 'object' ? mapping[key] : null;
        // if the key refers to an array, run through the array and apply all params
        if (Array.isArray(mappingKey)) {
            mappingKey.forEach((param) => {
                result += `${param}=${object[key]}&`;
            });
            return result;
        }
        // if the key refers to a nested object, recursively run this function
        if (typeof object[key] === 'object') {
            return `${result}${remapParams(object[key], nextMappingLevel)}`;
        }
        if (key === 'eventType') {
            // values get remapped for event types. Example 'screen' becomes '0'
            return `${result}${mappingKey}=${eventTypes[object[key]]}&`;
        }
        else {
            return `${result}${mappingKey}=${encodeURIComponent(object[key])}&`;
        }
    }, '');
};
const remap = (event) => {
    // get new object based on event type
    //@ts-ignore
    const eventMapping = paramMapping[event.eventType];
    if (!eventMapping)
        return null;
    const fullMapping = {
        ...baseParamMapping,
        ...eventMapping,
    };
    const result = remapParams(event, fullMapping);
    // strips off the trailing '&'
    return result.substring(0, result.length - 1);
};
export default remap;
//# sourceMappingURL=remapping.service.js.map